<template>
    <div>
        <b-modal id="matterMatterInfoFormModal" ref="matterMatterInfoFormModal" centered size="xl" no-close-on-backdrop :title= "$t('matter.case')"  hide-footer>
             <b-card>
             <b-row>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm"  @click.prevent="addorUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>   
            <b-row>
                <b-col class="col-lg-6">
                        <b-form>
                             <validation-observer ref="simpleRules">
                            <label for="matter-sub-type-input"> {{ $t('matter.matter_sub_type') }} </label>
                            <b-form-group>
                                <validation-provider :name=" $t('matter.matter_sub_type')" :rules="{ excluded:0}" v-slot="{ errors }">
                                    <b-form-select :state="errors.length > 0 ? false:null" v-model="matterSubTypeSelect" value-field="id" text-field="name" size="sm" :options="matterSubTypeOption" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            </validation-observer>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-6">
                        <b-form>
                            <label for="matter-case-type-input">{{ $t('matter.matter_case_type') }}</label>
                            <b-form-select size="sm" v-model="lawMatterCaseTypeSelect" value-field="id" text-field="name" :options="lawMatterCaseTypeOption" />
                        </b-form>
                    </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-info-subject-input">{{ $t('matterInfo.subject') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-info-subject-input" size="sm" v-model="subjectSelect" value-field="id" text-field="name" :options="subjectOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-info-court-input">{{ $t('matterInfo.court') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-info-court-input" size="sm" v-model="courtSelect" value-field="id" text-field="name" :options="courtOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-info-case-number-input">{{ $t('matterInfo.case_number') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="matter-info-case-number-input" v-model="caseNumber" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="matter-info-filed-on-date-input">{{ $t('matterInfo.filed_on_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('matterInfo.filed_on_date')" size="sm" v-model="date" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
                     <b-col v-if="matterSubTypeSelect == 1 && lawMatterPlaintiffAsString!= null" class="col-lg-12">
                        <b-form>
                            <label for="matter-libelee-input">{{ $t('matter.matter_libelee') }}</label>
                            <b-form-input size="sm" id="matter-libelee-input" v-model="lawMatterPlaintiffAsString" maxlength="50" disabled />
                        </b-form>
                    </b-col>
                    <b-col v-if="matterSubTypeSelect == 2 && lawMatterPlaintiffAsString!= null" class="col-lg-12">
                        <b-form>
                            <label for="matter-defendant-input">{{ $t('matter.matter_defendant') }}</label>
                            <b-form-input size="sm" id="matter-defendant-input" v-model="lawMatterPlaintiffAsString" maxlength="50" disabled />
                        </b-form>
                    </b-col>
            </b-row>
           </b-card>
            <b-card :hidden="id == 0">
                <b-row>
                    <b-col class="mt-2">
                         <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                            <b-tab :title="$t('matter.matter_defendant')" style="width:100%;">
                            <b-card-text>
                                <matter-plaintiff-list plaintiffOrLibelee="1" :lawMatterId="lawMatterId"></matter-plaintiff-list>
                            </b-card-text>
                            </b-tab>
                            <b-tab :title="$t('matter.matter_libelee')" style="width:100%;">
                            <b-card-text>
                                <matter-defendant-list  :lawMatterId="lawMatterId"></matter-defendant-list>
                            </b-card-text>
                        </b-tab>
                         <b-tab  :title="$t('matter.matter_first_instance_court')" style="width:100%;">
                            <b-card-text>
                                <matter-first-instance-court-list :lawMatterId="lawMatterId"></matter-first-instance-court-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_regional_court_of_appeal')" style="width:100%;">
                            <b-card-text>
                                <matter-regional-court-of-appeal-list :lawMatterId="lawMatterId"></matter-regional-court-of-appeal-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_appeal_info')" style="width:100%;">
                            <b-card-text>
                                <matter-appeal-info-list :lawMatterId="lawMatterId"></matter-appeal-info-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_supreme_court')" style="width:100%;">
                            <b-card-text>
                                <matter-supreme-court-list :lawMatterId="lawMatterId"></matter-supreme-court-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_decision_adjustments')" style="width:100%;">
                            <b-card-text>
                                <matter-decision-adjustments-list :lawMatterId="lawMatterId"></matter-decision-adjustments-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_finalization')" style="width:100%;">
                            <b-card-text>
                                <matter-finalization-list :lawMatterId="lawMatterId"></matter-finalization-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab  :title="$t('matter.matter_caution')" style="width:100%;">
                            <b-card-text>
                                <matter-caution-list :lawMatterId="lawMatterId"></matter-caution-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('matter.court_expert')" style="width:100%;">
                            <b-card-text>
                                <law-matter-court-expert-list :lawMatterId="lawMatterId"></law-matter-court-expert-list>
                            </b-card-text>
                        </b-tab>
                         <b-tab :title="$t('matter.matter_budget')" style="width:100%;">
                            <b-card-text>
                                <matter-budget-list :lawMatterId="lawMatterId"></matter-budget-list>
                            </b-card-text>
                        </b-tab>
                         </b-tabs>
                         
                    </b-col>
                </b-row>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
export default{
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            subjectSelect: 0,
            subjectOption: [],
            courtSelect: 0,
            courtOption: [],
            caseNumber: '',
            date: null,
            lawMatterId: 0,
            lawMatterCaseTypeOption: [],
            lawMatterCaseTypeSelect: 0,
            matterSubTypeOption: [],
            matterSubTypeSelect: 0,
            lawMatterPlaintiffAsString : '',
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
        }
    },
    methods:{
        showMatterInfo(id, lawMatterId){
            this.$refs['matterMatterInfoFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterInfo'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                        this.subjectSelect = response.data.lawMatterInfo.lawSubjectId
                        this.courtSelect = response.data.lawMatterInfo.lawAuthorityCourtId 
                        this.caseNumber = response.data.lawMatterInfo.caseNumber
                        this.date = response.data.lawMatterInfo.date
                        this.courtOption = response.data.lawAuthorityCourtList
                        this.subjectOption = response.data.lawSubjectList
                        this.matterSubTypeSelect = response.data.lawMatterInfo.lawMatterSubTypeId
                        this.matterSubTypeOption = response.data.lawMatterSubTypeList
                        this.matterSubTypeOption.splice(0, 0, this.$nullSelected())
                        this.lawMatterCaseTypeSelect = response.data.lawMatterInfo.lawMatterCaseTypeId
                        this.lawMatterCaseTypeOption = response.data.lawMatterCaseTypeList
                        this.lawMatterPlaintiffAsString = response.data.lawMatterPlaintiffAsString
                        this.lawMatterCaseTypeOption.splice(0, 0, this.$nullSelected())
                    if (this.subjectOption != null) {
                        this.subjectOption.splice(0, 0, this.$nullSelected())
                    }
                    if (this.courtOption != null) {
                        this.courtOption.splice(0, 0, this.$nullSelected())
                    }
                     this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                     this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                     this.lawMatterProcessResultSelect = response.data.lawMatterInfo.lawMatterProcessResultId

                } else {
                    this.$bvModal.hide('matterMatterInfoFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })           
            
        },
        async addorUpdate(){

            const lawMatterInfoData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawSubjectId: this.subjectSelect,
                            lawAuthorityCourtId : this.courtSelect,
                            caseNumber: this.caseNumber,
                            date: this.date,
                            lawMatterSubTypeId: this.matterSubTypeSelect,
                            lawMatterCaseTypeId: this.lawMatterCaseTypeSelect,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect
                        }
            const controller = {
                name: 'LawMatterInfo'
            }
            const payload = {
                data: lawMatterInfoData,
                controller: controller
            }
            const success = await this.$refs.simpleRules.validate()
            if(success){
                var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(1, this.id, this.lawMatterId,this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$SaveAlert()
            } else {
                    this.$WarningAlert(response.data.resultMessage)
              }
            }
        }
    }

    }

</script>